/*eslint-disable*/ export const messages = JSON.parse("{\"select.label.optional\":[\"(valgfritt)\"]}");
//# sourceMappingURL=messages.mjs.map